import {brandConfigObjectMap, Brands} from "@/brand/brandConfig";

export const brandConfigMap = new Map();

brandConfigMap.set('http://localhost:8080', getBrandConfig('vc-za-en'));
brandConfigMap.set('http://localhost:8081', getBrandConfig('wp-rn-za-en'));
brandConfigMap.set('http://192.168.88.28:8080', getBrandConfig('vc-za-en'));
brandConfigMap.set('https://staging.rugby-zone.co.za', getBrandConfig('vc-za-en'));
brandConfigMap.set('https://rugby-zone.co.za', getBrandConfig('vc-za-en'));
brandConfigMap.set('https://rugby-zone-co-za.migration.penrosesystems.com', getBrandConfig('vc-za-en'));
brandConfigMap.set('https://mtn.rugby-zone.co.za', getBrandConfig('mtn-za-en'));
brandConfigMap.set('https://wp.rugby-zone.co.za', getBrandConfig('wp-za-en'));
brandConfigMap.set('https://wp-play.rugby-zone.co.za', getBrandConfig('wp-za-en'));
brandConfigMap.set('https://rugganation.com', getBrandConfig('wp-rn-za-en'));
brandConfigMap.set('http://localhost:8082', getBrandConfig('vc-za-en'));

// Add a default fallback configuration
brandConfigMap.set('default', getBrandConfig('vc-za-en'));

export function getBrandConfig(brand) {
    const brandConfigObject = brandConfigObjectMap.get(brand);
    return {
        brand,
        gameTitle: brandConfigObject.gameTitle,
        freePlayServiceId: brandConfigObject.freePlayServiceId,
        newIntegration: brandConfigObject.newIntegration,
        baseRoute: brandConfigObject.baseRoute,
        productId: brandConfigObject.productId,
        logoLrg: brandConfigObject.logoLrg,
        logoSml: brandConfigObject.logoSml,
        // WorldPlay only: header vs main; other brands fall back to single logo
        logoHeaderLrg: brandConfigObject.logoHeaderLrg || brandConfigObject.logoLrg,
        logoHeaderSml: brandConfigObject.logoHeaderSml || brandConfigObject.logoSml,
        logoMainLrg: brandConfigObject.logoMainLrg || brandConfigObject.logoLrg,
        logoMainSml: brandConfigObject.logoMainSml || brandConfigObject.logoSml,
        // WP brands: medium logo for upcoming fixtures; others use header logo
        logoUpcomingFixtures: brandConfigObject.logoUpcomingFixtures || brandConfigObject.logoHeaderLrg || brandConfigObject.logoLrg,
        hasBracketGames: brandConfigObject.hasBracketGames,
        userAccessId: brandConfigObject.userAccessId || 11,
    }
}
